module.exports = __webpack_public_path__ + "static/media/68.8605f32.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/68.wav
// module id = TyPE
// module chunks = 0